import { createFileRoute } from '@tanstack/react-router';
import DocsGroupHome from '@/components/Docs/DocsGroupHome';

export const Route = createFileRoute('/developers/v1/')({
  component: DevelopersV1HomePage,
});

function DevelopersV1HomePage() {
  return <DocsGroupHome group="developers" version="v1" />;
}
